import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import { Form } from "ant-design-vue";

import { columns } from "./project-select-table.constant";
import { useEventbus } from "@/core";
import { ProfilePageReq } from "@/views/project";

import ProjectTypeSelect from "../project-type-select/index.vue";
import CompanySearchSelect from "../company-search-select/index.vue";
import SalesManSelect from "../sales-man-select/index.vue";
import { ProfileService } from "@/views/maintenance/project/project.service";
export default defineComponent({
  isGlobal: true,
  name: "ProjectSelectTable",
  components: { ProjectTypeSelect, CompanySearchSelect, SalesManSelect },
  props: {
    value: { type: String, default: undefined },
    projectId: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const visible = ref(false);
    const formItemContext = Form.useInjectFormItemContext();
    const selectedKeys = ref<any>({});
    const queryRef = reactive(new ProfilePageReq());
    let isError = ref(false);
    const { resetFields } = Form.useForm(queryRef, reactive({}));
    const { $on } = useEventbus();
    const {
      data: dataSource,
      loading,
      run,
      refresh,
      pagination,
    } = ProfileService.useProjectPageApi();
    const valueName = ref("");

    watch(
      () => props.value,
      async (n) => {
        if (n && n.length > 0) {
          valueName.value = n;
        }else{
          valueName.value = '';
        }

      },
      { immediate: true }
    );
    watch(
      () => props.projectId,
      (n, o) => {
        if (n && n.length > 0 && n != o) {
          // selectedKeys.value = { id: n, name: props.value };
        }
      },
      { immediate: true }
    );
    onMounted(async () => {
      // await runSimpleList();
    });

    const showModal = () => {
      visible.value = true;
    };

    const closeModal = () => {
      visible.value = false;
    };

    const ok = () => {
      if (selectedKeys.value) {
        valueName.value = selectedKeys.value.projectName;
        emit("update:value", selectedKeys.value["projectName"]);
        emit("change", selectedKeys.value);
        isError.value = false;
        formItemContext.onFieldChange();
      }
      closeModal();
    };

    const search = async () => {
      selectedKeys.value = [];
      queryRef.current = 1;
      await run(queryRef);
    };

    const reset = async () => {
      resetFields();
      await search();
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onRadioChange = ({ item }) => {
      // console.log("🚀 ~ file: project-select-table.controller.ts:83 ~ onRadioChange ~ item:", item);
      selectedKeys.value = item[0];
    };
    const inputChange = (e) => {
      // console.log("🚀 ~ file: project-select-table.controller.ts:87 ~ inputChange ~ e:", e);
      emit("update:value", valueName.value);
      emit("change", { projectName: valueName.value });
      formItemContext.onFieldChange();
    };
    const removeSelected = () => {
      emit("update:value", undefined);
      emit("change", undefined);
      isError.value = true;
    };

    onMounted(async () => {
      await search();
    });

    return {
      visible,
      showModal,
      closeModal,
      ok,
      selectedKeys,
      valueName,
      queryRef,
      loading,
      dataSource,
      columns,
      pagination,
      refresh,
      reset,
      search,
      onTableChange,
      onRadioChange,
      removeSelected,
      isError,
      inputChange,
    };
  },
});
